/**
 * GlowEffect - Decorative green/lime glow effect for dark theme
 * Used in auth forms (login, signup) cards
 * 
 * Based on Figma design: node 6:7967
 * Creates an elliptical radial gradient with blur at the bottom of container
 */
interface GlowEffectProps {
  className?: string
}

export const GlowEffect = ({ className = '' }: GlowEffectProps) => {
  return (
    <div 
      className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`}
    >
      {/* Main bottom glow - тонкая линия свечения внизу */}
      <div 
        className="absolute left-0 right-0 -bottom-[10px] h-[80px]"
        style={{
          background: 'linear-gradient(to top, rgba(155,180,30,0.9) 0%, rgba(130,155,25,0.5) 40%, transparent 100%)',
          filter: 'blur(15px)',
        }}
      />
      {/* Left vertical peak - узкая вертикальная полоса слева */}
      <div 
        className="absolute -left-[30px] bottom-0"
        style={{
          width: '120px',
          height: '85%',
          background: 'linear-gradient(to top, rgba(155,180,30,1) 0%, rgba(145,170,28,0.85) 30%, rgba(120,145,22,0.4) 60%, transparent 90%)',
          filter: 'blur(25px)',
        }}
      />
      {/* Right vertical peak - узкая вертикальная полоса справа */}
      <div 
        className="absolute -right-[30px] bottom-0"
        style={{
          width: '120px',
          height: '85%',
          background: 'linear-gradient(to top, rgba(155,180,30,1) 0%, rgba(145,170,28,0.85) 30%, rgba(120,145,22,0.4) 60%, transparent 90%)',
          filter: 'blur(25px)',
        }}
      />
    </div>
  )
}

export default GlowEffect

